// import Home from './routes/Home.svelte';
import AppGrantAccess from './routes/AppGrantAccess.svelte';
import LoginUser from './routes/LoginUser.svelte';
import RegisterUser from './routes/RegisterUser.svelte';
import Events from './routes/Events.svelte';
import EventDetaile from './routes/EventDetaile.svelte';

import NotFound from './routes/NotFound.svelte';

export default {
    '/': AppGrantAccess,
    '/register': RegisterUser,
    '/login': LoginUser,
    // '/access_application':
    '/events': Events,
    '/event_detaile': EventDetaile,
    // '/event/:event_id':

    // '/seleziona/:area?': SelectShop,
    // '/sellingservices/:storeslug': SellingServices,
    
    // The catch-all route must always be last
    '*': NotFound
};
